import React from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

type TaskLogsModalTitleProps = {
  title: string;
  onDownload: () => void;
  downloading: boolean;
  downloadDisabled?: boolean;
  downloadTooltip: string;
};

const TaskLogsModalTitle: React.FC<TaskLogsModalTitleProps> = ({
  title,
  onDownload,
  downloading,
  downloadDisabled,
  downloadTooltip,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      paddingRight: 28,
    }}
  >
    <span
      style={{
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </span>
    <Tooltip title={downloadTooltip}>
      <Button
        type="text"
        size="small"
        icon={<DownloadOutlined />}
        loading={downloading}
        disabled={downloadDisabled}
        onClick={onDownload}
        aria-label={downloadTooltip}
      />
    </Tooltip>
  </div>
);

export default TaskLogsModalTitle;
